import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth/auth.guard';

export const routes: Routes = [
    {
        path: 'auth', loadChildren: () => import('./auth/auth.routes').then((x) => x.authRoutes),
    },
    {
        path: 'rts', 
        loadChildren: () => import('./features/features.routes').then((x) => x.featuresRoutes),
        canMatch: [authGuard]
    },
    { path: '**', redirectTo: 'auth', pathMatch: 'full' }
];
